"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.showSingle = void 0;
var bigdata_stat_1 = require("../bigdata_stat");
var single_html_1 = __importDefault(require("./single.html"));
/** 显示底下单个的推广 */
function showSingle(tgdata) {
    var imgurl = tgdata.imgUrl[0];
    // let imgurl = 'https://mobappconfig.securities.eastmoney.com/appimg/21d0c605-6e03-4fc3-9852-685580c98a08.png'
    var eid = tgdata.eid;
    (0, bigdata_stat_1.sendStat)('DIV', 'Open', 'dfcfw.ggw.tc', { "eid": eid });
    var img = new Image();
    img.className = 'websitepoptg_img';
    var isLoaded = img.complete && img.naturalHeight !== 0;
    img.src = imgurl;
    var div = document.createElement('div');
    div.innerHTML = single_html_1["default"];
    div.querySelector('.tgimgc').appendChild(img);
    var close = div.querySelector('.tgclose');
    close.addEventListener('click', function (e) {
        (0, bigdata_stat_1.sendStat)('DIV', 'click', 'dfcfw.ggw.tcgb');
        document.body.removeChild(div);
        e.stopPropagation();
    });
    document.body.appendChild(div);
    if (isLoaded) {
        console.info('isLoaded');
        var tgimg = div.querySelector('.tgimg');
        tgimg.style.width = img.width + 'px';
    }
    else {
        img.addEventListener('load', function () {
            // console.info('load', img.width)
            // console.info('load', img.clientWidth)
            var tgimg = div.querySelector('.tgimg');
            tgimg.style.width = img.clientWidth + 'px';
        });
    }
    // document.addEventListener('click', function(e){
    //   try {
    //     let target = e.target as HTMLElement
    //     if(target && target.className != 'websitepoptg_img' && target.className != 'websitepoptg_single'){
    //       // sendStat('DIV', 'click', 'dfcfw.ggw.tcgb')
    //       document.body.removeChild(div)
    //       e.stopPropagation()
    //     }      
    //   } catch (error) {
    //   }
    // })
    // document.addEventListener("keydown", function(e) {
    //   try {
    //     // sendStat('DIV', 'click', 'dfcfw.ggw.tcgb')
    //     document.body.removeChild(div)        
    //   } catch (error) {
    //   }
    // });
}
exports.showSingle = showSingle;
